const genders = ['masculine', 'feminine', 'neuter', 'plural'];

export default genders;